const KIOSK_STORAGE_KEY = 'kioskMode';

export function isKioskModeActive() {
  try {
    return !!document.fullscreenElement || localStorage.getItem(KIOSK_STORAGE_KEY) === '1';
  } catch (_) {
    return !!document.fullscreenElement;
  }
}

export async function enterKioskMode() {
  try {
    if (!document.fullscreenElement) {
      await document.documentElement.requestFullscreen();
    }
    document.body.classList.add('kiosk-mode');
    localStorage.setItem(KIOSK_STORAGE_KEY, '1');
    return true;
  } catch (err) {
    console.debug('kiosk enter failed', err);
    return false;
  }
}

export async function exitKioskMode() {
  try {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    }
    document.body.classList.remove('kiosk-mode');
    localStorage.removeItem(KIOSK_STORAGE_KEY);
    return true;
  } catch (err) {
    console.debug('kiosk exit failed', err);
    return false;
  }
}

export async function toggleKioskMode() {
  if (document.fullscreenElement) {
    return exitKioskMode();
  }
  return enterKioskMode();
}
